/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFeedsSkeleton.defs.js'
export { main as default } from './getSuggestedFeedsSkeleton.defs.js'
